import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AboutusService } from 'src/services/aboutus.service';
// import { MessageService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { Carousel } from 'primeng/carousel';
import { SearchService } from 'src/services/search-service.service';
import { ProductService } from 'src/services/productservice';
import { AuthenticationService } from '@app/auth/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '@env/environment';

@Component({
  selector: 'special_interest',
  templateUrl: './special-intrest.component.html',
  styleUrls: ['./special-intrest.component.scss'],
  providers: [MessageService],
})
export class SpecialIntrestComponent implements OnInit {
  //variable declarations
  public title: string;
  public aboutUsDetails: any = { bannerImage: null, bannerTitle: null, content: null };
  public imagesList: any;
  public responsiveOptions: any;
  public sailSpecialIntrest: any;
  public romSpecialIntrest: any;
  public divSpecialIntrest: any;
  public culSpecialIntrest: any;
  public creSpecialIntrest: any;
  public fishSpecialIntrest: any;
  public specialIntrestList: any = [];
  public genSpecialIntrest: any = { bannerImage: null, bannerTitle: null, bannerContent: null };
  public specialIntrest: any;
  public pageNumber: number = 1;
  public highLightPageNumber: number = 0;
  placesToSeeData: any;
  thingsToDoData: any;
  highlightsProducts: any;
  currentUser: any;
  wishlistData: any;
  whistlist: any;
  showLoader: boolean;
  TestMonialData: any;
  language: string;
  lang: string;
  beforeHeadingContent: string;

  //constructor
  constructor(
    public routes: ActivatedRoute,
    public specialIntrestService: AboutusService,
    public router: Router,
    public searchService: SearchService,
    public productService: ProductService,
    public authenticationService: AuthenticationService,
    public messageService: MessageService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {
    Carousel.prototype.onTouchMove = () => {};
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '480px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }
  ngOnInit(): void {
    this.beforeHeadingContent = this.translate.instant('UNRIVALLED');
    this.showLoader = true;
    this.lang = localStorage.getItem('language');
    this.placesToSeeModule();
    this.thingsToDoModule();
    this.getBlogItems();
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentUser) {
      this.wishListDeatils();
    }
    this.getTestiMonial();
    this.generalSpecialIntrest();
    // this.getNature();
    // this.sailingSpecialIntrest();
    // this.romanceSpecialIntrest();
    // this.divingSpecialIntrest();
    // this.fishingSpecialIntrest();
    this.showLoader = false;
  }

  placesToSeeModule() {
    this.searchService
      .planYourVisitSearchListing('ATTRACTION', null, null, null, null, this.pageNumber)
      .subscribe((data) => {
        Array.from(data.products).map(async (mData: any) => {
          await this.searchService.getViewListingDetailsEn(mData.productId).subscribe((dataq: any) => {
            mData.productName = dataq.productName;
          });
          if (mData.productImage) {
            let img = mData.productImage.split('&');
            img[1] = 'fit=crop&w=400';
            img[2] = 'h=600';
            mData.productImage = img.join('&');
          }
          this.currentUser = this.authenticationService.currentUserValue;
          if (this.currentUser) {
            await this.searchService.getWishList().subscribe((wishlistData) => {
              Array.from(wishlistData).map((attData: any) => {
                if (mData.productId == attData.field_product_id) {
                  mData.wishlist = 'true';
                  //mData.color = '#00a7a6';
                  mData.color = '#e94363';
                }
              });
            });
          }
        });
        this.placesToSeeData = data.products;
        if (this.placesToSeeData && this.placesToSeeData.length == 1) {
          this.placesToSeeData.push({ productName: '' });
          this.placesToSeeData.push({ productName: '' });
          this.placesToSeeData.push({ productName: '' });
        }
        if (this.placesToSeeData && this.placesToSeeData.length == 2) {
          this.placesToSeeData.push({ productName: '' });
          this.placesToSeeData.push({ productName: '' });
        }
        if (this.placesToSeeData && this.placesToSeeData.length == 3) {
          this.placesToSeeData.push({ productName: '' });
        }
      });
  }

  thingsToDoModule() {
    this.searchService
      .planYourVisitSearchListing('EVENT,TOUR', null, 'WBTOURS,TRAIL', null, null, this.pageNumber)
      .subscribe((data) => {
        Array.from(data.products).map(async (mData: any) => {
          await this.searchService.getViewListingDetailsEn(mData.productId).subscribe((dataq: any) => {
            mData.productName = dataq.productName;
          });
          if (mData.productImage) {
            let img = mData.productImage.split('&');
            img[1] = 'fit=crop&w=400';
            img[2] = 'h=600';
            mData.productImage = img.join('&');
          }
          this.currentUser = this.authenticationService.currentUserValue;
          if (this.currentUser) {
            await this.searchService.getWishList().subscribe((wishlistData) => {
              Array.from(wishlistData).map((attData: any) => {
                if (mData.productId == attData.field_product_id) {
                  mData.wishlist = 'true';
                  //mData.color = '#00a7a6';
                  mData.color = '#e94363';
                }
              });
            });
          }
        });
        this.thingsToDoData = data.products;
      });
  }

  getCategoryItems(category: any) {
    var url = '/listingdetails/' + category.productId;
    window.open(url, '_blank');
  }

  getBlogItems() {
    const url = window.location.href;
    let specialInterestId = '346';
    if (url.indexOf('localhost') >= 0 || url.indexOf('staging') >= 0) {
      specialInterestId = '346';
    }
    this.language = localStorage.getItem('language').toLocaleLowerCase();
    this.productService
      .getSpecialInterestBlogs(this.highLightPageNumber, this.language, specialInterestId)
      .then((products) => {
        Array.from(products.results).map((data: any) => {
          data.title = data.title.replace('&#039;', "'");
          if (data.field_special_intrest) {
            let [num, specialIntrest] = data.field_special_intrest.toLowerCase().split(':');
            switch (specialIntrest) {
              case 'diving':
                data.specialInterestName = 'Diving';
                data.specialIntersetIcon = this.sanitizer.bypassSecurityTrustResourceUrl(
                  '../../assets/images/icons8-scuba-mask-50.svg'
                );
                break;
              case 'sailing':
                data.specialInterestName = 'Sailing';
                data.specialIntersetIcon = this.sanitizer.bypassSecurityTrustResourceUrl(
                  '../../assets/images/icons8-sail-boat-50.svg'
                );
                break;
              case 'fishing':
                data.specialInterestName = 'Fishing';
                data.specialIntersetIcon = this.sanitizer.bypassSecurityTrustResourceUrl(
                  '../../assets/images/icons8-fishing-50.svg'
                );
                break;
              case 'workcation':
                data.specialInterestName = 'Workcation';
                data.specialIntersetIcon = this.sanitizer.bypassSecurityTrustResourceUrl(
                  '../../assets/images/icons8-home-office-50.svg'
                );
                break;
              case 'romance':
                data.specialInterestName = 'Romance';
                data.specialIntersetIcon = this.sanitizer.bypassSecurityTrustResourceUrl(
                  '../../assets/images/icons8-romance-50.svg'
                );
                break;
              case 'nature':
                data.specialInterestName = 'Nature';
                data.specialIntersetIcon = this.sanitizer.bypassSecurityTrustResourceUrl(
                  '../../assets/images/icons8-leaf-50.svg'
                );
                break;
              // default:
              //   data.specialInterestName = this.sanitizer.bypassSecurityTrustResourceUrl('');
              //   break;
            }
          }
        });
        this.highlightsProducts = products.results;
      });
  }

  viewBlog(item: any) {
    var queryParams = this.productService.getBlogViewNode(item);
    var url = '/blog-details/' + item.nid + '/' + queryParams;
    window.open(url, '_blank');
  }

  getBlogUrl(item: any): string {
    var queryParams = this.productService.getBlogViewNode(item);
    return `/blog-details/${item.nid}/${queryParams}`;
  }

  addToWhishList(item: any) {
    this.wishListDeatils();
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentUser) {
      const prodcut = this.wishlistData.find((product: any) => product.field_product_id === item.productId);
      if (prodcut) {
        const wishlist = this.wishlistData.find((product: any) => product.field_product_id === item.productId);
        if (wishlist) {
          this.searchService.removeWishListDeatils(wishlist.nid).subscribe(
            (data) => {
              // this.whistlist = this.whistlist.filter((product: any) => product.productId !== item.productId);
              item.color = '#bbbbbb';
              this.messageService.add({
                key: 'add-wishlist',
                severity: 'success',
                summary: this.translate.instant('Success'),
                detail: this.translate.instant('Wishlist-Remove-Successfull'),
              });
              this.wishListDeatils();
            },
            (err) => {
              this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
            }
          );
        }
      } else {
        this.wishListDeatils();
        if (this.wishlistData.length >= 10) {
          this.messageService.add({
            key: 'add-wishlist',
            severity: 'info',
            summary: 'Info',
            detail: this.translate.instant('WhishList-Exceed-Message'),
          });
        } else {
          this.searchService.postWishList(item.productId, 'special', []).subscribe((result: any) => {
            if (result) {
              //item.color = '#00a7a6';
              item.color = '#e94363';
              this.messageService.add({
                key: 'add-wishlist',
                severity: 'success',
                summary: this.translate.instant('Success'),
                detail: this.translate.instant('Wishlist-Add-Successfull'),
              });
              this.wishListDeatils();
            }
          });
        }
      }
    } else {
      this.messageService.add({
        key: 'add-wishlist',
        severity: 'info',
        summary: 'Info',
        detail: this.translate.instant('WhishList-Login-Alert'),
      });
    }
  }
  wishListDeatils() {
    this.searchService.getWishList().subscribe((wishlistData) => {
      const productItem = wishlistData.map((productId: any) => `"${productId.field_product_id}"`).join(',');
      this.wishlistData = wishlistData;
      if (productItem !== '') {
        this.searchService.wishListDeatils(productItem).subscribe((data) => {
          this.whistlist = data.products;
          // this.searchService.getWishList().subscribe((wishlistData) => {
          //   this.wishlistData=[];
          //   this.wishlistData = wishlistData;
        });
      }
    });
  }
  scollBottom() {
    window.scrollTo({
      top: 540,
      behavior: 'smooth',
    });
  }
  getTestiMonial() {
    try {
      this.productService.getTestiMonial().then((res) => {
        this.TestMonialData = res;
      });
    } catch (error) {}
  }

  generalSpecialIntrest() {
    this.specialIntrestService.getSpecialIntrest().subscribe(
      (data) => {
        this.genSpecialIntrest = data;
        // this.specialIntrestList.push(this.genSpecialIntrest);
      },
      (err) => {
        alert(err.message);
      }
    );
  }
  getNature() {
    this.specialIntrestService.getGeneralSpecialIntrest().subscribe(
      (data) => {
        //  this.genSpecialIntrest = data;
        this.specialIntrestList.push(data);
      },
      (err) => {
        alert(err.message);
      }
    );
  }
  sailingSpecialIntrest() {
    this.specialIntrestService.getSailingSpecialIntrest().subscribe(
      (data) => {
        this.sailSpecialIntrest = data;
        this.specialIntrestList.push(this.sailSpecialIntrest);
      },
      (err) => {
        alert(err.message);
      }
    );
  }
  romanceSpecialIntrest() {
    this.specialIntrestService.getRomanceSpecialIntrest().subscribe(
      (data) => {
        this.romSpecialIntrest = data;
        this.specialIntrestList.push(this.romSpecialIntrest);
      },
      (err) => {
        alert(err.message);
      }
    );
  }
  divingSpecialIntrest() {
    this.specialIntrestService.getDivingSpecialIntrest().subscribe(
      (data) => {
        this.divSpecialIntrest = data;
        this.specialIntrestList.push(this.divSpecialIntrest);
      },
      (err) => {
        alert(err.message);
      }
    );
  }
  cultureSpecialIntrest() {
    this.specialIntrestService.getCultureSpecialIntrest().subscribe(
      (data) => {
        this.culSpecialIntrest = data;
        this.specialIntrestList.push(this.culSpecialIntrest);
      },
      (err) => {
        alert(err.message);
      }
    );
  }
  creoleSpecialIntrest() {
    this.specialIntrestService.getCreoleSpecialIntrest().subscribe(
      (data) => {
        this.creSpecialIntrest = data;
        this.specialIntrestList.push(this.creSpecialIntrest);
      },
      (err) => {
        alert(err.message);
      }
    );
  }
  fishingSpecialIntrest() {
    this.specialIntrestService.getFishingSpecialIntrest().subscribe(
      (data) => {
        this.fishSpecialIntrest = data;
        this.specialIntrestList.push(this.fishSpecialIntrest);
        this.specialIntrest = this.specialIntrestList;
      },
      (err) => {
        alert(err.message);
      }
    );
  }
  getSpecialIntrestDetails(selectedValue: any) {
    if (selectedValue) {
      var catNames = selectedValue.toLowerCase();
    }
    // if (catNames == 'nature') {
    //   catNames = 'nature';
    // }
    if (catNames == 'special interest') {
      this.router.navigate(['/special_interest']);
    } else {
      this.router.navigate(['/special_interest/' + catNames]);
    }
    //   var selectedIntrestName = selectedValue.toLowerCase();
    //   this.specialIntrestService.getSpecialIntrestDetails(selectedIntrestName).subscribe((data)=>{
    //     this.genSpecialIntrest = [];
    //     this.genSpecialIntrest = data;
    //  },
    //  (err) => {
    //   alert(err.message);
    //  })
  }
}
